import jwtDecode from "jwt-decode";

export function decodeJwt(token) {
  return jwtDecode(token);
}

export function getExpiryMins(expiry) {
  const currentDate = new Date();
  const currentDateInSec = currentDate.getTime() / 1000;
  const minsToExpire =
    (Number(expiry) - Number(Math.floor(currentDateInSec))) / 60;
  return minsToExpire;
}

// export default class jwt {
//   static decodeJwt = token => {
//     return jwtDecode(token);
//   };

//   static getExpiryMins = expiry => {
//     const currentDate = new Date();
//     const currentDateInSec = currentDate.getTime() / 1000;
//     const minsToExpire =
//       (Number(expiry) - Number(Math.floor(currentDateInSec))) / 60;

//     return minsToExpire;
//   };
// }
